import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";
import CampaignContext from "../../../../contexts/CampaignContext";
import UserContext from "../../../../contexts/UserContext";
import {
  leaderboardFiltersState,
  leaderboardState,
  setLeaderboard,
  setLeaderboardFilters,
} from "../../../../redux/entriesSlice";
import restService from "../../../../restService";
import { KEYCLOAK_TOKEN } from "../../../../utilities";
import { DatePicker } from "../../../components";
import SearchInput from "../../../components/search-input";
import LeaderboardCard from "./card";
import ExportLeaderboardData from "./export-leaderboard";
import LeaderboardTable from "./table";

import _ from "lodash";

import ExportReportButton from "../../../components/export-modal";

import { toast } from "react-toastify";

const chunkSize = 1000;

export default function LeaderboardPage() {
  const [user] = useContext(UserContext);
  const dispatch = useDispatch();

  const controllerRef = useRef(null);

  const leaderboard = useSelector(leaderboardState);
  const leaderboardFilters = useSelector(leaderboardFiltersState);

  const dateRange = leaderboardFilters.dateRange;

  const [campaign] = useContext(CampaignContext);

  const [isLoading, setIsLoading] = useState(false);
  // const [entrants, setEntrants] = useState([]);
  const [totalPoints, setTotalPoints] = useState(0);
  // const [topThree, setTopThree] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [previousItems, setPreviousItems] = useState(null);

  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const observerTarget = useRef(null);

  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [entries, setEntries] = useState([]);

  const indexOfLastPage = page * itemsPerPage;
  const indexOfFirstPage = indexOfLastPage - itemsPerPage;

  const totalPointsReducer = (acc, curr) => acc + Number(curr?.points);

  const calculateTotalPoints = (loyaltyPoints) => {
    let totalPoints = 0;

    for (let i = 0; i < loyaltyPoints.length; i += chunkSize) {
      const chunk = loyaltyPoints.slice(i, i + chunkSize);
      totalPoints += chunk.reduce(totalPointsReducer, 0);
    }

    return totalPoints;
  };

  function mergeEntries(newData) {
    const filteredStateData = entries.filter(
      (existingItem) =>
        !newData?.some((newItem) => _.isEqual(existingItem, newItem))
    );

    // Concatenate filtered existing data with new data
    const updatedLeaderboard = [...filteredStateData, ...newData];

    const sorted = (updatedLeaderboard || [])?.sort((a, b) => {
      return b.loyaltyPoints - a.loyaltyPoints;
    });

    const sortedDate = (sorted || [])?.slice()?.map((item) => {
      return {
        position: sorted?.indexOf(item) + 1,
        name: item?.name,
        userId: item?.userId,
        location: item?.location,
        loyaltyPoints: item?.loyaltyPoints,
      };
    });

    setEntries(sortedDate);
  }

  async function getLeaderboardData() {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    setIsFetchingMore(true);
    console.log(entries?.length);
    if (!entries?.length) {
      setIsLoading(true);
    }
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    let token = sessionStorage.getItem(KEYCLOAK_TOKEN);

    try {
      const { data } = await restService.Entries.getLeaderboard({
        campaignId: campaign?.id,
        access_token: token,
        startDate: new Date(dateRange?.[0]?.startDate)
          ?.toISOString()
          .slice(0, -5),
        page: currentPage,
        limit: 50,
        endDate: new Date(dateRange?.[0]?.endDate)?.toISOString().slice(0, -5),
        signal,
      });

      const content = data?.data?.content?.[0];
      const totalPoints = content?.totalPoints;
      const totalEntries = content?.content;
      const _totalPages = data?.data?.totalPages;

      setTotalPages(_totalPages);

      // const sorted = (totalEntries || [])?.sort((a, b) => {
      //   return b.loyaltyPoints - a.loyaltyPoints;
      // });

      // const updatedData = (sorted || [])?.map((item) => {
      //   return {
      //     position: sorted?.indexOf(item) + 1,
      //     customer: item?.name,
      //     contact: item?.userId,
      //     location: item?.location,
      //     points: item?.loyaltyPoints,
      //   };
      // });

      mergeEntries(totalEntries || []);
      setPreviousItems(totalEntries || []);

      setTotalPoints(totalPoints);
      // dispatch(setLeaderboard(totalEntries || []));
      setIsLoading(false);
      setIsFetchingMore(false);
    } catch (error) {
      console.log(error?.message);
      if (error?.message === "canceled") return;
      if (error?.message?.includes("setting")) return;

      console.log(error);
      setIsLoading(false);
      setIsFetchingMore(false);
    }
  }

  function handleResetData() {
    dispatch(setLeaderboard([]));
    setCurrentPage(1);
  }

  function position(index) {
    if (index === 0) {
      return "first";
    }

    if (index === 1) {
      return "second";
    }

    if (index === 2) {
      return "third";
    }

    return null;
  }

  // useEffect(() => {
  //   const __totalPoints = calculateTotalPoints(leaderboard || []);
  //   setTotalPoints(__totalPoints);
  // }, []);

  useEffect(() => {
    getLeaderboardData();
  }, [dateRange, currentPage]);

  const filteredEntrants = entries?.slice()?.filter((item) => {
    if (!searchValue) return item;

    if (isNaN(Number(searchValue))) {
      return (
        item?.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item?.location?.toLowerCase().includes(searchValue.toLowerCase())
      );
    }

    if (!isNaN(Number(searchValue))) {
      return item?.userId?.includes(searchValue);
    }

    return [];
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          if (currentPage === totalPages || isFetchingMore) {
            return;
          }

          if (previousItems && previousItems.length < 1) {
            return;
          }

          if (searchValue) {
            return;
          }

          setIsFetchingMore(true);
          setCurrentPage(currentPage + 1);
        }
      },
      { threshold: 1 }
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => {
      if (observerTarget.current) {
        observer.unobserve(observerTarget.current);
      }
    };
  }, [observerTarget, totalPages, currentPage, isFetchingMore, searchValue]);

  const exportEntries = async (recipient) => {
    try {
      const end = dateRange[0].endDate
        ? new Date(dateRange[0].endDate).toISOString()
        : "";
      const start = dateRange[0].startDate
        ? new Date(dateRange[0].startDate).toISOString()
        : "";

      await restService.Entries.exportLeaderboard({
        campaignId: campaign?.id,
        startDate: start,
        endDate: end,
        token: user?.accessToken,
        emailRecipient: recipient,
      });
    } catch (error) {
      console.log(error);
      throw new Error("something went wrong");
    }
  };

  function exportLeaderboardEntries(recipient) {
    toast.promise(exportEntries(recipient), {
      pending: "Sending report",
      success: "Report sent!",
      error: "Something went wrong. Please try again later",
    });
  }

  return (
    <div className="h-full md:px-8 flex flex-col gap-6 w-full">
      <div className="flex items-center md:flex-row flex-col justify-between gap-2">
        <div className="flex items-start gap-4">
          <h1 className="text-2xl leading-9 font-[600]">Leaderboard</h1>
          <div className=" w-full border rounded md:w-auto mt-2 md:mt-0">
            <DatePicker
              state={dateRange}
              setState={(range) => {
                handleResetData();
                dispatch(
                  setLeaderboardFilters({
                    ...leaderboardFilters,
                    dateRange: range,
                  })
                );
              }}
            />
          </div>
        </div>
        <div className="flex items-center justify-end gap-4">
          <p className="text-sm text-[#848484]">Total points</p>

          <p className="bg-[#ff00001a] text-[#ff0000] rounded px-4 py-2">
            {totalPoints?.toLocaleString()}
          </p>
        </div>
      </div>

      <div className="flex md:flex-row flex-col gap-4">
        {entries?.slice(0, 3)?.map((item, index) => {
          return (
            <LeaderboardCard
              key={index}
              position={position(index)}
              points={item?.loyaltyPoints?.toLocaleString()}
            />
          );
        })}
      </div>

      <div className="my-6 align-middle py-4 shadow flex flex-col gap-4 bg-white w-full">
        <div className="flex md:flex-row justify-between px-4 flex-col gap-2">
          <SearchInput
            onChange={(e) => {
              const value = e.target?.value;
              setSearchValue(value);
              // handleSearch(value);
            }}
          />

          <div className="">
            <ExportReportButton
              user={user}
              handleExport={(recipient) => exportLeaderboardEntries(recipient)}
            />
          </div>
        </div>

        <div className="w-full  overflow-auto">
          <LeaderboardTable entrants={filteredEntrants} isLoading={isLoading} />
          {isFetchingMore && (
            <p className="flex items-center w-full justify-center">
              <div className="my-8 mx-auto">
                <PulseLoader size={8} color="#FF6A3A" />
              </div>
            </p>
          )}
          <div ref={observerTarget}></div>
        </div>
      </div>
    </div>
  );
}
